<template>
      <list
            :columns="columns"
            :modalCreate="modalCreate"
            :removeLink="removeLink"
            :cardLink="cardLink"
            :isUpdate="true"
            :isAdd="true"
            :itemLink="itemLink"
            :setLink="setLink"
            :openItem="false"
            :fields="fields"
            :searchDisable="true"
            @change="change"
            @changeFunction="changeFunction"
            v-model="val"
      />
</template>
<script>
export default {
  name: "products",
  props:['id'],
  created(){
    this.itemLink = `businesses/${this.id}/disciplines`;
    this.setLink = `businesses/${this.id}/disciplines`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  
  },
  data() {
    return {
      val: [],
      modalCreate: "client_group",
      fields: [
          {
              col:'col-12 col-md-6',
              label: "Выберите предмет",
              key: "disciplines",
              type: "selects",
              selectKey: "title",
              modal: "discipline",
              prefix: "discipline_b_d",
          },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_discipline",
      itemLink: "",
      setLink: "",
      columns: [
          {
            key: "title",
            title: "Предмет",
            checkbox: false,

          },
       
          {
              detail: true,
              remove: true,
          },
      ],
    };
  },
};
</script>
<style>
</style>
